"use strict";

import { createRuntimeFn as _7a468 } from "@vanilla-extract/recipes/createRuntimeFn";
export var checkbox = "Checkbox_checkbox__10euuyhf Buttons_buttonReset__yodxo10 Controls_controlFocusRing__a2bdyy2";
export var container = "Checkbox_container__10euuyh0";
export var content = _7a468({
  defaultClassName: "Checkbox_content__10euuyh4",
  variantClassNames: {
    disabled: {
      true: "Checkbox_content_disabled_true__10euuyh5"
    },
    size: {
      s: "Checkbox_content_size_s__10euuyh6",
      m: "Checkbox_content_size_m__10euuyh7",
      l: "Checkbox_content_size_l__10euuyh8"
    }
  },
  defaultVariants: {},
  compoundVariants: []
});
export var error = "Checkbox_error__10euuyhk";
export var errorIcon = "Checkbox_errorIcon__10euuyhl";
export var indicator = _7a468({
  defaultClassName: "Checkbox_indicator__10euuyhg",
  variantClassNames: {
    visible: {
      true: "Checkbox_indicator_visible_true__10euuyhh"
    }
  },
  defaultVariants: {},
  compoundVariants: []
});
export var label = _7a468({
  defaultClassName: "Checkbox_label__10euuyhi",
  variantClassNames: {
    hidden: {
      true: "Checkbox_label_hidden_true__10euuyhj"
    }
  },
  defaultVariants: {},
  compoundVariants: []
});